import { z } from 'zod';
import { tenantIdSchema } from '../ids/index.js';
export const tenantRegime = {
    simplificado: 'simplificado',
    comun: 'comun',
};
export const tenantSchema = z.object({
    id: tenantIdSchema,
    slug: z.string().min(1).max(64).regex(/^[a-z0-9-]+$/),
    name: z.string().min(1).max(200),
    legalName: z.string().max(200).nullable().default(null),
    nit: z.string().max(20).nullable().default(null),
    dv: z.string().max(2).nullable().default(null),
    regime: z.enum(['simplificado', 'comun']).default('simplificado'),
    responsibilityCodesJson: z.string().default('[]'),
    economicActivityCode: z.string().max(10).nullable().default(null),
    municipalityCode: z.string().max(10).nullable().default(null),
    country: z.string().length(2).default('CO'),
    currency: z.string().length(3).default('COP'),
    timezone: z.string().default('America/Bogota'),
    active: z.boolean().default(true),
    createdAt: z.number().int(),
    updatedAt: z.number().int(),
});
export const tenantFeatureSchema = z.object({
    tenantId: tenantIdSchema,
    featureId: z.string().min(1).max(64),
    enabled: z.boolean(),
    configJson: z.string().default('{}'),
    activatedAt: z.number().int().nullable().default(null),
    updatedAt: z.number().int(),
});
// Catálogo canónico de features (ids, kinds, presets) vive en ./features/index.ts.
//# sourceMappingURL=tenant.js.map